import { createContext, useContext, useEffect, useState } from "react";
import { api, imageUrl } from "@/lib/api";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

const FALLBACK = {
    store_name: "Opensea Fishing Tackles",
    tagline: "Premium fishing gear, built for the pursuit.",
    currency_symbol: "Rs.",
    logo_url:
        "https://customer-assets.emergentagent.com/job_98d63437-58f0-458d-ad8f-bdf2ebbc1d64/artifacts/agswg8ik_Opensea_PNG_Logo.png",
    instagram_url: "https://instagram.com/openseafishingtackles",
    instagram_section_enabled: true,
    instagram_handle: "@openseafishingtackles",
    free_shipping_threshold: 1499,
    free_shipping_enabled: true,
    cod_enabled: true,
    contact_email: "osefishingtackles@gmail.com",
    contact_phone: "",
    address: "India",
    // Storefront assets — empty means: storefront uses its built-in fallback image.
    favicon_url: "",
    hero_desktop_url: "",
    hero_mobile_url: "",
    category_tile_default_url: "",
    product_default_url: "",
    instagram_tile_default_url: "",
};

function applyFavicon(url) {
    if (typeof document === "undefined") return;
    const href = url ? imageUrl(url) : "";
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    if (href) link.href = href;
}

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(FALLBACK);

    const refresh = async () => {
        try {
            const { data } = await api.get("/store/settings");
            const merged = { ...FALLBACK, ...data };
            setSettings(merged);
            if (merged.favicon_url) applyFavicon(merged.favicon_url);
        } catch (_) {
            setSettings(FALLBACK);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>
    );
}

export const useSettings = () => useContext(SettingsContext);
